import { render, staticRenderFns } from "./gestionProveedor.vue?vue&type=template&id=0a5e3514&scoped=true"
import script from "./gestionProveedor.vue?vue&type=script&lang=js"
export * from "./gestionProveedor.vue?vue&type=script&lang=js"
import style0 from "./gestionProveedor.vue?vue&type=style&index=0&id=0a5e3514&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a5e3514",
  null
  
)

export default component.exports